import { B as BROWSER, D as DEV } from "./prod-ssr.js";
const browser = BROWSER;
const dev = DEV;
export {
  browser as b,
  dev as d
};
